import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { useSearch } from "../SearchContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import useTranslation from "./customHooks/translations";
import { useParams } from "react-router-dom";
import { _get } from "../services/apiClient";

const MenuItem = lazy(() => import("./MenuItem"));

function MenuSection({ handleClick, cart, setCart, products, subCategories }) {
  const { searchData, filtersubCategory, filter, setFilter } = useSearch();
  //   console.log(filtersubCategory);
  const [categories, setCategories] = useState([]);
  const { id } = useParams();
  //const {categoryname}=subCategories?.[0].category;
  let filteredItemsFound = 0;
  const [MenuList, setMenuList] = useState([]);
  const [categoryname, setCategoryName] = useState("");
  const [observer, setObserver] = useState(null);
  const elementRef = useRef(null);
  const translation = useTranslation();

  //   const [isVeg, setIsVeg] = useState(false);
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    navigate(`/products/${categoryId}`);
  };

  const fetchCategoriesData = async () => {
    try {
      const response = await _get(`/categories`);
      setCategories(response.data);
      setCategoryName(response.data.find((x) => x.id == id)?.name || "");
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  //   const handleToggle = () => {
  //     const nextValue = !isVeg;
  //     setIsVeg(nextValue);
  //     setFilter(nextValue ? "veg" : "");
  //   };

  useEffect(() => {
    const fetchProductsByCategory = async () => {
      try {
        const response = await _get(`/products?category=${id}`);

        setMenuList(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    if (id) {
      fetchCategoriesData();
      fetchProductsByCategory();
    }
  }, [id]);

  useEffect(() => {
    fetchCategoriesData();
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMenuItem();
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, options);
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    setObserver(observer);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  const loadMenuItem = () => {
    import("./MenuItem").then((mod) => { });
  };
  useEffect(() => { }, []);

  return (
    <>
      <div className="container position-relative">
        {/* sticky-top */}
        <div className="p-3 m-0 bg-light  w-100 top-heightset">
          <div className="d-flex justify-content-between align-items-center">
            <div className="page-breadcrumb mb-0">
              <ul className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/" className="text-dark">
                    <i
                      className="bi bi-house-fill"
                      style={{ fontSize: "0.9rem" }}
                    ></i>
                  </a>
                </li>
                <li className="breadcrumb-item active">{categoryname}</li>
              </ul>
            </div>

            {/* <div
              className="d-flex align-items-center gap-2"
              onClick={handleToggle}
              style={{ cursor: "pointer", userSelect: "none" }}
            >
              <span className="fw-medium">Veg</span>

              <div
                className="position-relative"
                style={{
                  width: "46px",
                  height: "24px",
                  backgroundColor: isVeg ? "grey" : "#ccc",
                  borderRadius: "30px",
                  transition: "background-color 0.3s ease",
                }}
              >
                <div
                  style={{
                    width: "18px",
                    height: "18px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "3px",
                    left: isVeg ? "24px" : "4px",
                    transition: "left 0.3s ease",
                  }}
                ></div>
              </div>
            </div> */}
          </div>
        </div>

        <div>
          {Array.isArray(subCategories) &&
            subCategories.map((section, index) => {
              const filteredSectionItems = products.filter((item) => {
                const matchesSubcategory = item.subcategory === section._id;

                const matchesSearch = searchData
                  ? item.productName
                    .toLowerCase()
                    .includes(searchData.toLowerCase())
                  : true;

                const matchesSubCatFilter = filtersubCategory
                  ? item.subcategory === filtersubCategory
                  : true;

                // const matchesVegFilter = isVeg ? item.isVeg === true : true;

                // return (
                //   matchesSubcategory &&
                //   matchesSearch &&
                //   matchesSubCatFilter &&
                //   matchesVegFilter
                // );
                return matchesSubcategory && matchesSearch && matchesSubCatFilter;

              });

              if (filteredSectionItems.length !== 0) {
                filteredItemsFound = 1;

                return (
                  <div key={index}>
                    <div
                      className="w-100"
                      id={`SectionName${section.id}d`}
                      style={{ paddingTop: "5px" }}
                      onClick={() => handleClick(section)}
                    ></div>
                    <h6
                      className="p-3 m-0 bg-light w-100 top-heightset"
                      name="fixedMenuHeader"
                    >
                      {section.subCat}
                      {/* <small className="text-black-50">  {filteredSectionItems.length} ITEMS </small> */}
                    </h6>
                    <div className="most_sale">
                      <div className="row mb-3 mt-5">
                        <Suspense
                          fallback={
                            <div>
                              <p>
                                <i>Loading...</i>
                              </p>{" "}
                            </div>
                          }
                        >
                          {filteredSectionItems.map((detail, detailIndex) => (
                            <MenuItem
                              key={detailIndex}
                              MenuItem={detail}
                              handleClick={handleClick}
                              products={MenuList}
                              cart={cart}
                              setCart={setCart}
                            />
                          ))}
                        </Suspense>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
        </div>
        {filteredItemsFound !== 1 && (
          <div>
            <h6 className="p-3 m-0 bg-white text-danger w-100">
              {translation.filterditem}
            </h6>
          </div>
        )}
        <div
          className="dropdown dropup "
          style={{
            position: "fixed",
            bottom: "70px",
            right: "30px",
            zIndex: "1000",
          }}
        >
          <button
            id="menucategories"
            className="btn btn-dark dropstart btn-sm rounded-pill px-2 py-1 dropdown-toggle text-dark small font-weight-bold d-flex align-items-center"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <p className="h6 text-center mt-0 text-white">
              <i className="feather-list"></i> Category
            </p>
          </button>
          <div className="container">
            <ul className="dropdown-menu custom-dropdown-menu dropdown-menu.show border pb-2 text-dark shadow">
              <li className="dropdown-header h5 fw-bold text-dark bg-secondary-subtle division">
                Category List
              </li>
              <hr className="dropdown-divider" />
              {categories.map((section, index) => (
                <li key={index}>
                  <button
                    className="dropdown-item d-flex justify-content-between rounded-2"
                    onClick={() => handleCategoryClick(section.id)}
                    style={{
                      backgroundColor:
                        section.id == id ? "#ccc" : "transparent",
                      color: section.id == id ? "black" : "inherit",
                    }}
                  >
                    <span>{section.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
          {/* <div className='arrow' style={{position:'absolute'}}></div> */}
        </div>
      </div>
    </>
  );
}

export default MenuSection;
